import axios from 'axios';

import api from '../utils/api';

const UPLOAD_URL_API_RESOURCE_MAPPING = {
  inventory: getInventoryUploadUrl,
  pricing: getPricingUploadUrl,
  products: getProductAutomationUploadUrl,
};

export async function uploadFileToPreSignedUrl({
  supplierId,
  file,
  resourceType = 'pricing',
  contentType = 'text/csv',
}) {
  const uploadApi = UPLOAD_URL_API_RESOURCE_MAPPING[resourceType];
  if (!uploadApi) throw new Error('Invalid resource type for upload');

  const { url, path } = await uploadApi(supplierId);

  const response = await axios({
    method: 'PUT',
    url,
    data: file,
    headers: {
      'Content-Type': contentType,
    },
  });

  if (response?.status !== 200) {
    throw new Error(`Error uploading ${resourceType} file`);
  }

  return { path, url };
}

async function getPricingUploadUrl(supplierId) {
  const response = await api.post(`/suppliers/${supplierId}/pricing/upload-url`);
  if (!response?.data?.success) throw new Error('Error getting pricing uploadUrl');

  return response.data;
}

async function getInventoryUploadUrl(supplierId) {
  const response = await api.post(`/suppliers/${supplierId}/variants/upload-url`);
  if (!response?.data?.success) throw new Error('Error getting inventory uploadUrl');

  return response.data;
}

async function getProductAutomationUploadUrl(supplierId) {
  const response = await api.post(`/product-automation/suppliers/${supplierId}/upload-url`);
  if (!response?.data?.success) throw new Error('Error getting products uploadUrl');

  return response.data;
}
